/* eslint-disable */
export default `<section class="race-event ob-results-rendered">
    <header class="race-event__header">
        <div class="race-header">
            <p class="race-header__name">
                <%= data.name %>
                <% if (data.distance) { %>
                <span class="race-header__distance">
                        (<%= data.distance.miles %>m <%= data.distance.furlongs %>f <%= data.distance.yards %>y)
                    </span>
                <% } %>
            </p>
            <div class="race-header__toolbar">
                <a href="javascript:void(0)" class="race-header__toolbar-item race-header__toolbar-item--tv">
                    <i class="race-header__toolbar-icon icon-tv"></i>
                </a>
            </div>
        </div>
        <section class="race-event__meta-details">
            <section class="race-overview">
                <ul class="fl race-event__overview">
                    <% if (!data.isQuantumLeapCompetition) { %>
                    <li><span class="logo-racing-post"></span> <span class="bold"><%= translator.translate('views.templates.racecards.verdict') %></span>
                    <% } %>
                    </li>
                    <% if (data.eachway_terms) { %>
                    <li><span class="bold"><%= translator.translate('views.templates.racecards.eachWayTerms') %></span>
                        <%= data.eachway_terms.factor.num %>/<%= data.eachway_terms.factor.den %> <%=
                        translator.translate('views.templates.racecards.odds') %> <%= data.eachway_terms.num_places %>
                        <%= translator.translate('views.templates.racecards.places') %>
                    </li>
                    <% } %>
                    <li><span class="bold"><%= translator.translate('views.templates.racecards.offTime') %></span> <%=
                        data.off_date %>
                    </li>
                    <li><span class="bold"><%= data.num_runners %> <%= translator.translate('views.templates.racecards.ranSettled') %></span>
                    </li>
                    <% if (data.winning_time) { %>
                    <li><span class="bold"><%= translator.translate('views.templates.racecards.winningTime') %></span>
                        <%= data.winning_time %>
                    </li>
                    <% } %>
                </ul>
            </section>
        </section>
    </header>

    <% if (data.runners) { %>

    <section class="racecard result clickable-selections">
        <header class="racecard-header">
            <span class="racecard-header__pos"><%= translator.translate('views.templates.racecards.pos') %></span>
            <span class="racecard-header__number"><%= translator.translate('views.templates.racecards.no') %></span>
            <span class="racecard-header__selection"><%= translator.translate('views.templates.racecards.selection') %></span>
            <% if (data.hasSP) { %>
            <span class="racecard-header__sp"><%= translator.translate('views.templates.racecards.sp') %></span>
            <% } %>
            <% if (data.hasDividends) { %>
            <span class="racecard-header__tote-win"><%= translator.translate('views.templates.racecards.tote_win') %></span>
            <span class="racecard-header__tote-place"><%= translator.translate('views.templates.racecards.tote_place') %></span>
            <% } %>
        </header>
        <div class="racecard__main">

            <% data.runners.forEach(function(runner) { %>

            <article class="racecard-runner">
                <section class="racecard-runner__main-details racecard-runner__main-details--results ">
                    <div class="racecard-runner__column-pos racecard-runner__column-pos--horse">
                        <span class="racecard-runner__pos"><%= runner.position %><sup><%= runner.positionExt %></sup></span>
                        <% if (runner.beaten_distance) { %>
                        <span class="racecard-runner__dist"><%= runner.beaten_distance %></span>
                        <% } %>
                    </div>
                    <div class="racecard-runner__column-number racecard-runner__column-number--horse">
                        <span class="racecard-runner__number racecard-runner__number--horse"><%= runner.pos %></span>
                        <% if (runner.number) { %>
                        <span class="racecard-runner__draw-number">(<%= runner.number %>)</span>
                        <% } %>
                    </div>
                    <% if (runner.silk) { %>
                    <div class="racecard-runner__column-draw">
                        <img src="<%= data.silkImageBaseURL %><%= runner.silk %>" alt="" class="racecard-runner__silk">
                    </div>
                    <% } %>
                    <div class="racecard-runner__column-selection racecard-runner__column-selection--racing">
                        <div class="racecard-runner__name-container racecard-runner__name-container--horse">
                            <span class="racecard-runner__name"><%= runner.name %></span>
                        </div>
                        <% if (runner.jockey || runner.trainer) { %>
                        <dl class="racecard-runner__selection-data racecard-runner__selection-data--horse">
                            <% if (runner.jockey) { %>
                            <dt class="racecard-runner__selection-data-label fl"><%=
                                translator.translate('views.templates.racecards.jockey') %>
                            </dt>
                            <dd class="racecard-runner__selection-data-name fl"><%= runner.jockey %></dd>
                            <% } %>
                            <% if (runner.trainer) { %>
                            <dt class="racecard-runner__selection-data-label fl"><%=
                                translator.translate('views.templates.racecards.trainer') %>
                            </dt>
                            <dd class="racecard-runner__selection-data-name fl"><%= runner.trainer %></dd>
                            <% } %>
                        </dl>
                        <% } %>
                    </div>
                    <% if (runner.start_price || runner.live_price || runner.is_1_fav || runner.is_2_fav) { %>
                    <div class="racecard-runner__sp">
                        <% if (runner.start_price) { %>
                        <%= runner.start_price.num %>/<%=runner.start_price.den %>
                        <% } else if (runner.live_price) { %>
                        <%= runner.live_price.num %>/<%=runner.live_price.den %>
                        <% } %>
                        <% if (runner.is_1_fav) { %>
                        (F)
                        <% } else if (runner.is_2_fav) { %>
                        (2F)
                        <% } %>
                    </div>
                    <% } %>
                    <% if (runner.dividends) { %>
                    <div class="racecard-runner__tote-win">
                        <% if (runner.dividends.tote_win) { %>
                        <%= runner.dividends.tote_win[0] %>
                        <% } else { %>
                        -
                        <% } %>
                    </div>
                    <div class="racecard-runner__tote-place">
                        <% if (runner.dividends.tote_place) { %>
                        <%= runner.dividends.tote_place[0] %>
                        <% } else { %>
                        -
                        <% } %>
                    </div>
                    <% } %>
                </section>
                <% if (runner.racing_post_comment) { %>
                <p class="racecard-runner__notes"><%= runner.racing_post_comment %></p>
                <% } %>
            </article>

            <% }); %>
        </div>
    </section>
    <footer class="race-event__footer">
        <div class="group">
            <% if (data.dividends) { %>
            <ul class="race-event__overview">
                <% if (data.dividends.forecast) { %>
                <li><span class="bold"><%= translator.translate('views.templates.racecards.forecast') %></span> <%=
                    data.dividends.forecast[0].toFixed(2) %>
                </li>
                <% } %>
                <% if (data.dividends.tricast) { %>
                <li><span class="bold"><%= translator.translate('views.templates.racecards.tricast') %></span> <%=
                    data.dividends.tricast[0].toFixed(2) %>
                </li>
                <% } %>
            </ul>
            <% } %>
            <ul class="race-event__overview">
                <% if (data.favourites.first) { %>
                <li><span class="bold"><%= translator.translate('views.templates.racecards.first') %></span> <%=
                    data.favourites.first.name %>
                </li>
                <% } %>
                <% if (data.favourites.second) { %>
                <li><span class="bold"><%= translator.translate('views.templates.racecards.second') %></span> <%=
                    data.favourites.second.name %>
                </li>
                <% } %>
                <% if (data.nonRunners.length) { %>
                <li><span class="bold"><%= translator.translate('views.templates.racecards.nonRunners') %></span>
                    <%=
                    data.nonRunners.map(function(nonRunner) {
                    return nonRunner.name;
                    }).join(', ')
                    %>
                </li>
                <% } %>
            </ul>
        </div>
        <% if (data.dividends && (data.dividends.tote_exacta || data.dividends.tote_swinger ||
        data.dividends.tote_trifecta)) { %>
        <div class="group">
            <p>
                <% if (data.dividends.tote_exacta) { %>
                <span class="bold"><%= translator.translate('views.templates.racecards.tote_exacta') %></span> <%=
                data.dividends.tote_exacta %> |
                <% } %>
                <% if (data.dividends.tote_swinger) { %>
                <span class="bold"><%= translator.translate('views.templates.racecards.tote_swinger') %></span> <%=
                data.dividends.tote_swinger %> |
                <% } %>
                <% if (data.dividends.tote_trifecta) { %>
                <span class="bold"><%= translator.translate('views.templates.racecards.tote_trifecta') %></span> <%=
                data.dividends.tote_trifecta %>
                <% } %>
            </p>
        </div>
        <% } %>
        <% if ((data.rule4_deductions && data.rule4_deductions.length) || data.hasDeadHeat) { %>
        <div class="group">
            <% if (data.rule4_deductions && data.rule4_deductions.length) { %>
            <p><a href="javascript:void(0)" class="bold"><%=
                translator.translate('views.templates.racecards.rule4_deductions') %></a></p>
            <% data.rule4_deductions.forEach(function(rule4) { %>
            <p><span class="bold"><%= rule4.name %></span> <%=
                translator.translate('views.templates.racecards.rule4_desc', {
                deduction: rule4.deduction,
                datetime_from: rule4.datetime_from,
                datetime_to: rule4.datetime_to
                }) %></p>
            <% }); %>
            <% } %>
            <% if (data.hasDeadHeat) { %>
            <p><a href="https://williamhill-lang.custhelp.com/app/answers/detail/a_id/135/kw/dead%20heat" class="bold"><%=
                translator.translate('views.templates.racecards.tc') %></a></p>
            <% } %>
        </div>
        <% } %>
    </footer>

    <% } %>

</section>`;
